export const COLORS = {
  primary: '#8B5CF6',
  primaryDark: '#6D28D9',
  primaryLight: '#EDE9FE',
  primaryBorder: '#DDD6FE',
  secondary: '#F59E0B',
  success: '#10B981',
  error: '#EF4444',
  warning: '#F59E0B',
  white: '#FFFFFF',
  black: '#111827',
  text: '#1F2937',
  textMuted: '#6B7280',
  bg: '#F9FAFB',
  bgCard: '#FFFFFF',
  border: '#E5E7EB',
};

export const ROLES = {
  USER: 'user',
  BUSINESS: 'business',
  ADMIN: 'admin',
};

export const BUSINESS_TYPES = {
  FIXED: 'fixed',
  MOBILE: 'mobile',
  HYBRID: 'hybrid',
};

export const BOOKING_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled',
};
